import { EU_COUNTRIES } from './eu-countries'
import { domReady } from '@/utils/dom-ready'

function showOrHideEuContent() {
  const countrySelect = document.querySelector('.eu-only-content-switcher')
  const consentWrapper = document.querySelector('.eu-data-processing-consent-wrapper')
  if (!countrySelect || !consentWrapper) {
    return
  }

  consentWrapper.style.display = EU_COUNTRIES.includes(countrySelect.value) ? 'block' : 'none'
}

document.addEventListener('change', (event) => {
  if (event.target.matches('.eu-only-content-switcher')) {
    showOrHideEuContent()
  }
})

domReady(showOrHideEuContent)
document.addEventListener('form:loaded', showOrHideEuContent)
